"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverclaimSearchFilters = void 0;
const form_field_types_1 = require("@App/enum/form-field-types");
const overclaimStatusFilterGroup = {
    name: 'Status of Overclaim',
    allowMultiple: true,
    filterFields: [
        {
            status: {
                name: 'status',
                label: '',
                type: form_field_types_1.FormFieldTypes.CHECKBOX_GROUP,
                checkboxes: [
                    {
                        id: 'OVERCLAIM',
                        label: 'Overclaim',
                    },
                    {
                        id: 'DISPUTE',
                        label: 'Dispute',
                    },
                    {
                        id: 'RESOLVED',
                        label: 'Resolved',
                    },
                    {
                        id: 'MERGED',
                        label: 'Merged',
                    },
                    {
                        id: 'CANCELED',
                        label: 'Canceled',
                    },
                ],
            },
        },
    ],
};
const overclaimSortByFilterGroup = {
    name: 'Sort By',
    allowMultiple: false,
    filterFields: [
        {
            sort: {
                type: form_field_types_1.FormFieldTypes.RADIO,
                name: 'sort',
                options: [
                    { name: 'overclaim_creation_date', label: 'Most Recent Overclaim', default: true },
                    { name: 'documentation_due_date', label: 'Remaining Action Time' },
                ],
                optional: false,
                label: '',
            },
        },
    ],
};
const overclaimDocumentStatusFilterGroup = {
    name: 'Document Status',
    allowMultiple: true,
    filterFields: [
        {
            documentationStatus: {
                name: 'documentationStatus',
                label: '',
                type: form_field_types_1.FormFieldTypes.CHECKBOX_GROUP,
                checkboxes: [
                    {
                        id: 'DOCUMENT_NEEDED',
                        label: 'Document Needed',
                    },
                    {
                        id: 'DOCUMENT_PENDING',
                        label: 'Document Pending Review',
                    },
                    {
                        id: 'DOCUMENT_ACCEPTED',
                        label: 'Document Accepted',
                    },
                ],
            },
        },
    ],
};
const overclaimAmendmentStatusFilterGroup = {
    name: 'Amendment Status',
    allowMultiple: true,
    filterFields: [
        {
            amendmentStatus: {
                name: 'amendmentStatus',
                label: '',
                type: form_field_types_1.FormFieldTypes.CHECKBOX_GROUP,
                checkboxes: [
                    {
                        id: 'AMENDMENT_NEEDED',
                        label: 'Document Needed',
                    },
                    {
                        id: 'AMENDMENT_PENDING',
                        label: 'Document Pending Review',
                    },
                    {
                        id: 'AMENDMENT_ACCEPTED',
                        label: 'Document Accepted',
                    },
                ],
            },
        },
    ],
};
exports.OverclaimSearchFilters = [
    overclaimStatusFilterGroup,
    overclaimSortByFilterGroup,
    overclaimDocumentStatusFilterGroup,
    overclaimAmendmentStatusFilterGroup,
];
